import { Option } from '../../../../components/SelectOption/SelectOption';
import { THERMOCOUPLE_LIMITS } from '../../../../constants/common';
import i18n from '../../../../infrastructure/i18n';

const ChannelOutputStateAction = {
  ENABLE: '0',
  DISABLE: '1',
};
export const thermocoupleOptions: Option[] = Array(THERMOCOUPLE_LIMITS.MAX)
  .fill(0)
  .map((_, idx) => ({ id: `${idx + 1}`, value: `${idx + 1}` }));

export const enableOption: Option = {
  id: ChannelOutputStateAction.ENABLE,
  value: i18n.t('statuses.output.actions.enable'),
};

export const disableOption: Option = {
  id: ChannelOutputStateAction.DISABLE,
  value: i18n.t('statuses.output.actions.disable'),
};

export const outputChangeOptions: Option[] = [enableOption, disableOption];
